<template>
  <el-cascader
    class="rxk_area"
    v-bind="getBindValue"
    :options="province"
    :props="regionData"
    v-model="input"
    @change="handleChange"
    ref="area"
  />
  <RxkInput
    type="textarea"
    placeholder="请输入详细地址"
    @blur="handleBlur"
    v-if="getBindValue.showArea"
    v-bind="getBindValue"
    v-model.trim="areaInputValue"
  />
</template>
<script lang="ts" setup>
import province from 'province-city-china/dist/level.json'
import { RxkInput } from '@/components/common/RxkInput'
import { computed, ref } from 'vue'
defineOptions({
  name: 'RxkArea'
})
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  },
  placeholder: {
    type: String,
    default: '请输入'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  showArea: {
    type: Boolean,
    default: true
  },
  areaValue: {
    type: String,
    default: ''
  },
  regionData: {
    type: Object,
    default: () => ({
      value: 'code',
      label: 'name'
    })
  }
})
const getBindValue = computed(() => {
  return props
})
const emit = defineEmits([
  'update:modelValue',
  'update:areaValue',
  'change',
  'getAreaLabel',
  'blur'
])
const area = ref(null)
const handleChange = v => {
  emit('change', v)
  const labelArray = area.value?.getCheckedNodes?.()[0]?.pathLabels ?? []
  emit('getAreaLabel', labelArray)
}
const handleBlur = () => {
  emit('blur')
}
const input = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})
const areaInputValue = computed({
  get() {
    return props.areaValue
  },
  set(value) {
    emit('update:areaValue', value)
  }
})
</script>
<style lang="scss">
@import './index.scss';
</style>
